module.exports = __webpack_public_path__ + "static/voa_banner-923f300a15d08a52d80a979d7cd1836b.png";